<lib-modal #modal [preventCloseOnOverlayClick]="true">
  <lib-modal-dialog class="cookie-policy-modal">
    <lib-modal-dialog-body class="cookie-policy-modal__body">
      <div class="cookie-policy-modal__body-image">
        <img class="cookie-policy-modal__body-logo" src="assets/images/pitchbook-logo.png" alt="PitchBook" />
      </div>

      <div class="cookie-policy-modal__body-title">We need your consent to proceed to PitchBook SFTP</div>

      <div class="cookie-policy-modal__body-message">
        Our site uses cookies to store user access data. <br />
        You can configure your preferences at any time using the cookie policy tool.
      </div>
    </lib-modal-dialog-body>

    <lib-modal-dialog-footer class="cookie-policy-modal__footer">
      <lib-button [type]="buttonType.Secondary" (click)="onButtonClick()"> Agree and Enter </lib-button>
    </lib-modal-dialog-footer>
  </lib-modal-dialog>
</lib-modal>
